import { render } from "./_form.vue?vue&type=template&id=3dec41a2"
import script from "./_form.vue?vue&type=script&lang=js"
export * from "./_form.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vendor/vvg/forum/resources/vue/reaction/_form.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3dec41a2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3dec41a2', __exports__)) {
    console.log('reload')
    api.reload('3dec41a2', __exports__)
  }
  
  module.hot.accept("./_form.vue?vue&type=template&id=3dec41a2", () => {
    console.log('re-render')
    api.rerender('3dec41a2', render)
  })

}


export default __exports__